import { removeNullValues } from '@domgen/dgx-fe-common';
import { formatProvinceCode, USProvinceName } from '@domgen/dgx-fe-i18n';
import {
  PaysafeCustomerDetails,
  PaysafeFormValue,
} from '@checkout/util-models';

export function formatPaysafeCustomerDetails(
  formValue: PaysafeFormValue
): PaysafeCustomerDetails | undefined {
  formValue = removeNullValues(formValue);

  if (!formValue.accountName) {
    return undefined;
  }

  return {
    holderName: formValue.accountName,
    billingDetails: {
      city: formValue.billingAddress.addressLine3,
      country: formValue.billingAddress.countryIso2,
      state: formatProvinceCode(
        formValue.billingAddress.addressLine4,
        USProvinceName
      ),
      street: formValue.billingAddress.addressLine1,
      street2: formValue.billingAddress.addressLine2,
      zip: formValue.billingAddress.postalCode,
      useAsShippingAddress: false,
    },
    shippingDetails: {
      city: formValue.address.addressLine3,
      country: formValue.address.countryIso2,
      state: formatProvinceCode(formValue.address.addressLine4, USProvinceName),
      street: formValue.address.addressLine1,
      street2: formValue.address.addressLine2,
      zip: formValue.address.postalCode,
    },
  };
}
